import { createContext, useContext } from 'react';
import type { MerchantOrderStatusEnum } from '@/graphql/generatedTypes';

export interface OrderMutationHandlers {
  onCancel: (ids: string[]) => Promise<void>;
  onUpdateStatus: (
    ids: string[],
    status: MerchantOrderStatusEnum,
  ) => Promise<void>;
  onRefetchOrderDocuments?: (ids: string[]) => Promise<void>;
  onRefetchDeliveryNote?: (ids: string[]) => Promise<void>;
}

const OrderMutationsContext = createContext<OrderMutationHandlers | null>(null);

export const OrderMutationsProvider = OrderMutationsContext.Provider;

export function useOrderMutations(): OrderMutationHandlers {
  const ctx = useContext(OrderMutationsContext);
  if (!ctx)
    throw new Error(
      'useOrderMutations must be used within OrderMutationsProvider',
    );
  return ctx;
}
